import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

export function convertCibData(
	request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem {
	const productData = { ...response };

	if (!response.marketing || response.name !== "CIB Előrelépő Személyi Kölcsön") {
		return productData;
	}

	productData.marketing.highlight = true;
	const totalIncome = request.incomeList.reduce((sum, income) => income.amount + sum, 0);

	if (totalIncome < 120_000) {
		productData.marketing.newTargetUrl = "https://ad.adverticum.net/C/5829968/5829969/582997100?";
		productData.marketing.avTrackingCode =
			"https://ad.adverticum.net/t/?z=5829968&g=5829969&b=582997100&h=[LOCATION]&p=2";
	} else if (totalIncome < 250_000) {
		productData.marketing.newTargetUrl = "https://ad.adverticum.net/C/5829978/5829979/582998100?";
		productData.marketing.avTrackingCode =
			"https://ad.adverticum.net/t/?z=5829978&g=5829979&b=582998100&h=[LOCATION]&p=2";
	} else {
		productData.marketing.newTargetUrl = "https://ad.adverticum.net/C/5829989/5829990/582999200?";
		productData.marketing.avTrackingCode =
			"https://ad.adverticum.net/t/?z=5829989&g=5829990&b=582999200&h=[LOCATION]&p=2";
	}

	return productData;
}
